'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMCheckbox = require('./OMCheckbox.scss');var styles = _interopRequireWildcard(_OMCheckbox);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMCheckbox = function OMCheckbox(properties) {var _cx, _cx2, _cx3;var
  id = properties.id,label = properties.label,field = properties.field,className = properties.className,withoutLabel = properties.withoutLabel,customCheckBox = properties.customCheckBox,notValid = properties.notValid;
  return (
    _react2.default.createElement('label', {
        htmlFor: id || field.value,
        className: (0, _classnames2.default)(
        styles.omCheckbox,
        className,
        customCheckBox, (_cx = {}, _cx[
        styles.indent] = field.name === 'entry_date.immediate', _cx), (_cx2 = {}, _cx2[
        styles.withoutLabel] = withoutLabel, _cx2), (_cx3 = {}, _cx3[
        styles.not_valid] = notValid, _cx3)) },


      _react2.default.createElement('input', _extends({ id: id || field.value, type: 'checkbox' }, field)),

      _react2.default.createElement('span', null, label)));


};exports.default =

OMCheckbox;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMCheckbox/OMCheckbox.js
// module id = 385
// module chunks = 0